
import firebase from 'firebase/app';
import 'firebase/auth';        // for authentication
import 'firebase/storage';     // for storage
import 'firebase/database';    // for realtime database
import 'firebase/firestore';   // for cloud firestore

const config = {
  apiKey: "AIzaSyBl0I2Sr4Iu4-CmfKGcQDXLST08cxfJswA",
  authDomain: "saudebazi-18025.firebaseapp.com",
  databaseURL: "https://saudebazi-18025-default-rtdb.firebaseio.com",
  projectId: "saudebazi-18025",
  storageBucket: "saudebazi-18025.appspot.com",
  messagingSenderId: "805538316482",
  appId: "1:805538316482:web:d876a078d5732f0161bb5b",
  measurementId: "G-VD7250YZNW"
};
firebase.initializeApp(config);
firebase.auth().setPersistence(
  firebase.auth.Auth.Persistence.LOCAL
);
firebase.firestore().enablePersistence();

export default firebase;

